import { render, staticRenderFns } from "./feedback.detail.modal.vue?vue&type=template&id=2243dc0e"
import script from "./feedback.detail.modal.vue?vue&type=script&lang=js"
export * from "./feedback.detail.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports